import { makeServerProps } from '@/server/query'

import makePage from '@/client/services/pages/makePage'

import { useUserFromQuery, useUserUpcomingSeries } from '@/components/Profile/helpers'
import ProfileLayout from '@/components/Profile/ProfileLayout'
import ProfileSessionsTab from '@/components/Profile/ProfileSessionsTab'

function ProfileFeedback(): JSX.Element {
  const { user, userIdQuery } = useUserFromQuery()

  const upcomingSeries = useUserUpcomingSeries()

  return (
    <ProfileLayout currentTab="Sessions">
      <ProfileSessionsTab user={user} userIdQuery={userIdQuery} upcomingSeries={upcomingSeries} />
    </ProfileLayout>
  )
}

const ProfileFeedbackPage = makePage(ProfileFeedback, {
  onboardingUsers: 'allowed',
})
export const getServerSideProps = makeServerProps(ProfileFeedbackPage)
export default ProfileFeedbackPage
